<template>
  <WorkIconButton 
    v-bind="$props"
    :icon="icon"
    v-on="$listeners"
  >
    <template
      v-if="internalTooltip"
      #tooltip
    >
      {{ internalTooltip }}
    </template>
  </WorkIconButton>
</template>

<script>
import WorkIconButton from '@/components/global_components/buttons/WorkIconButton.vue';
import { filterProps } from '@/utils/functional-component-utils';

export default {
  name: 'WorkGlobalIconButton',
  components: {
    WorkIconButton,
  },
  props: {
    ...filterProps(WorkIconButton.props, ['icon', 'tooltip']),
  },
  data() {
    return {
      icon: undefined,
      tooltip: undefined,
    };
  },
  computed: {
    internalTooltip() {
      if (!!this.$scopedSlots.tooltip) {
        const slotContent = this.$scopedSlots.tooltip();
        if (Array.isArray(slotContent) && slotContent[0]) {
          return slotContent[0].text ??  slotContent[0].children[0]?.text;
        }
      }
      return this.tooltip;
    }
  },
};
</script>